<div id="user" class="page-layout emma simple carded fullwidth">
    <div class="header accent">
        @if (pageType == "edit") {
            <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/admin/users'">
                <mat-icon>arrow_back</mat-icon>
            </button>
        }

        @if (pageType == "new") {
            <h1>{{ "USERS.User" | translate }} - {{ "USERS.Create" | translate }}</h1>
        }
        @if (pageType == "edit") {
            <h1>{{ "USERS.User" | translate }} - {{ user.name }}</h1>
        }
    </div>

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- MAT TAB GROUP -->
            <mat-tab-group [backgroundColor]="'header'">
                <!-- USER INFO TAB -->
                <mat-tab label="{{ 'USERS.BasicInfo' | translate }}">
                    <div class="content">
                        <form name="userForm" [formGroup]="userForm" class="user">
                            <div class="section">
                                <!-- Nanem Field -->
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "USERS.Name" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="name"
                                        formControlName="name"
                                        placeholder="{{ 'USERS.Name' | translate }}"
                                        required
                                    />
                                </mat-form-field>

                                <!-- Email Field -->
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "USERS.Email" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="email"
                                        formControlName="email"
                                        placeholder="{{ 'USERS.Email' | translate }}"
                                        required
                                    />
                                </mat-form-field>

                                <!-- Password field (if present) -->
                                @if (pageType == "new") {
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "USERS.Password" | translate }}</mat-label>
                                        <input
                                            matInput
                                            type="password"
                                            name="password"
                                            formControlName="password"
                                            placeholder="{{ 'USERS.Password' | translate }}"
                                            required
                                        />
                                        @if (userForm.get("password").hasError("required")) {
                                            <mat-error>{{ "USERS.PasswordRequired" | translate }}</mat-error>
                                        }
                                        @if (userForm.get("password").hasError("minlength")) {
                                            <mat-error>
                                                {{ "USERS.PasswordMinLength" | translate: { minLength: minLength } }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <div class="password-policy">{{ passwordPolicyHint }}</div>
                                }

                                <!-- Administrator Field -->
                                <mat-slide-toggle name="isAdmin" formControlName="isAdmin">
                                    <mat-label>{{ "USERS.IsAdmin" | translate }}</mat-label>
                                </mat-slide-toggle>
                            </div>

                            @if (pageType == "edit") {
                                <div class="section password-reset-section">
                                    <div class="section__title">
                                        <mat-icon>lock_reset</mat-icon>
                                        <span>{{ "USERS.PasswordResetTitle" | translate }}</span>
                                    </div>
                                    <div class="password-policy">{{ passwordPolicyHint }}</div>

                                    <form name="resetPasswordForm" [formGroup]="resetPasswordForm" class="user">
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "USERS.NewPassword" | translate }}</mat-label>
                                            <input
                                                matInput
                                                type="password"
                                                formControlName="password"
                                                placeholder="{{ 'USERS.NewPassword' | translate }}"
                                            />
                                            @if (resetPasswordForm.get("password").hasError("required")) {
                                                <mat-error>{{ "USERS.PasswordRequired" | translate }}</mat-error>
                                            }
                                            @if (resetPasswordForm.get("password").hasError("minlength")) {
                                                <mat-error>
                                                    {{ "USERS.PasswordMinLength" | translate: { minLength: minLength } }}
                                                </mat-error>
                                            }
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "USERS.ConfirmPassword" | translate }}</mat-label>
                                            <input
                                                matInput
                                                type="password"
                                                formControlName="confirmPassword"
                                                placeholder="{{ 'USERS.ConfirmPassword' | translate }}"
                                            />
                                            @if (resetPasswordForm.get("confirmPassword").hasError("required")) {
                                                <mat-error>{{ "USERS.ConfirmPasswordRequired" | translate }}</mat-error>
                                            }
                                        </mat-form-field>

                                        <div class="form-action">
                                            <button
                                                mat-raised-button
                                                class="button-save"
                                                color="primary"
                                                [disabled]="resetPasswordForm.invalid"
                                                (click)="resetPassword()"
                                            >
                                                {{ "USERS.ResetPasswordButton" | translate }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            }

                            <div class="form-action">
                                @if (pageType == "new") {
                                    <button
                                        mat-raised-button
                                        class="button-save"
                                        color="primary"
                                        [disabled]="userForm.invalid"
                                        (click)="add()"
                                    >
                                        {{ "USERS.ADD" | translate }}
                                    </button>
                                }
                                @if (pageType == "new") {
                                    <button mat-raised-button (click)="cancel()">
                                        {{ "USERS.CANCEL" | translate }}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </mat-tab>
                <!-- PROJECTS TAB -->
                @if (pageType == "edit") {
                    <mat-tab label="{{ 'USERS.Projects' | translate }}">
                        <div class="project-content" fusePerfectScrollbar>
                            <app-project-list selectionControl="toggle" (rowSelect)="onProjectCheck($event)"></app-project-list>
                        </div>
                    </mat-tab>
                }
                <!-- COMPANIES TAB -->
                @if (pageType == "edit") {
                    <mat-tab label="{{ 'USERS.Companies' | translate }}">
                        <div class="company-content" fusePerfectScrollbar>
                            <app-company-list selectionControl="toggle" (rowSelect)="onCompanyCheck($event)"></app-company-list>
                        </div>
                    </mat-tab>
                }
                <!-- / MAT TAB GROUP -->
            </mat-tab-group>
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
